import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-chart-fullscreen',
  templateUrl: './chart-fullscreen.component.html',
  styleUrls: ['./chart-fullscreen.component.css']
})
export class ChartFullscreenComponent {
  selectedDeviceIDs: number[] = [];
  selectedMeasure!: string;
  selectedDuration!: string | null;
  formattedStartDate!: string | null;
  formattedEndDate!: string | null;
  iaqDevices: any[] = [];

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const key = params['key'];
      if (key) {
        const data = sessionStorage.getItem(key);
        if (data) {
          const chartData = JSON.parse(data);

          this.selectedDeviceIDs = chartData.selectedDeviceIDs;
          this.selectedMeasure = chartData.selectedMeasure;
          this.selectedDuration = chartData.selectedDuration;
          this.formattedStartDate = chartData.formattedStartDate;
          this.formattedEndDate = chartData.formattedEndDate;
          this.iaqDevices = chartData.iaqDevices;
        }
      }
    });
  }
}
